import { APIS } from "./api-factory";
import axios from 'axios'



export const login = (payload,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.LOGIN_MERCHANT(payload.merchantCode,payload.password) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getMonthlyLeads = (doctorId,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_MONTHLY_LEADS(doctorId) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getLoanAmount = (doctorId,st,ed,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_LOAN_AMOUNT(doctorId,st,ed) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getClinics = (callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_ALL_CLINIC() , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getChildGraphAction = (doctorId,type,loanStatus,st,ed,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_GRAPH_CHILD(doctorId,st,ed,type,loanStatus) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getParentGraphAction = (type,loanStatus,st,ed,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_GRAPH_PARENT(localStorage.getItem("doctorId") ?? "",st,ed,type,loanStatus) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}
export const getQr = (callBack) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_QR() , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e)
        })
}
export const getDoctorDetailsApi = (callBack) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_DOCTOR_DETAILS() , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e)
        })
}
export const getDoctorDashboardData = (doctorId, startDate, endDate, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_DOCTOR_DASHBOARD_DATA(doctorId, startDate, endDate) , headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            if (error) error(e)
        })
}

export const downloadMisReport = (sDate, eDate, doctorCode, type = 'all', callBack, error) => {
    axios.get(APIS.DOWNLOAD_MIS_REPORT(sDate, eDate, doctorCode, type), {
        responseType: 'blob',
        headers: {
            Accept: '*/*',
        },
    })
        .then(async (res) => {
            const contentType = res.headers['content-type'] || '';

            if (contentType.includes('application/json')) {
                const text = await res.data.text();
                let message = 'Failed to download report';
                try {
                    const parsed = JSON.parse(text);
                    message = parsed.message || parsed.data || message;
                } catch (e) {
                    message = text || message;
                }
                throw new Error(message);
            }

            const disposition = res.headers['content-disposition'] || '';
            const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)/i);
            const extension = contentType.includes('spreadsheet') || contentType.includes('excel')
                ? 'xlsx'
                : contentType.includes('csv')
                    ? 'csv'
                    : contentType.includes('pdf')
                        ? 'pdf'
                        : 'xlsx';
            const filename = match
                ? decodeURIComponent(match[1])
                : `mis-report-${sDate}-to-${eDate}.${extension}`;

            const blob = new Blob([res.data], { type: contentType || 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            if (callBack) {
                callBack({
                    filename,
                    format: extension.toUpperCase(),
                    contentType,
                });
            }
        })
        .catch((e) => {
            if (error) error(e);
        });
};